import * as components from './components'

export default [
  {
    path: '/pricelist',
    component: components.Pricelist,
    name: 'pricelist'
  }
]
